// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// narinosouvenirs.colombia@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyDTnhA1tE00E_qWkMAXN8und3aOW6SkuMY",
    authDomain: "jgoptica.firebaseapp.com",
    projectId: "jgoptica",
    storageBucket: "jgoptica.firebasestorage.app",
    messagingSenderId: "441945395746",
    appId: "1:441945395746:web:1ff22e9afd58591ba3f07b",
    measurementId: "G-W39V6YXKRK"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)